import type { IStatusPanelComp, IStatusPanelParams } from 'ag-grid-community';
import { TFunction } from 'react-i18next';

export class RestoreDefaultStatusBarComponent implements IStatusPanelComp {
  params!: IStatusPanelParams & {
    t: TFunction<'translation', undefined>;
    onResetFilters?: () => void;
  };
  eGui!: HTMLDivElement;
  eButton!: HTMLButtonElement;
  buttonListener: any;

  init(
    params: IStatusPanelParams & {
      t: TFunction<'translation', undefined>;
      onResetFilters?: () => void;
    }
  ) {
    this.params = params;

    this.eGui = document.createElement('div');
    this.eGui.className = 'ag-status-name-value';

    this.eButton = document.createElement('button');
    this.eButton.className = 'btn btn-secondary';

    this.buttonListener = this.onButtonClicked.bind(this);
    this.eButton.addEventListener('click', this.buttonListener);
    this.eButton.textContent = this.params.t('common.grid.reset');

    this.eGui.appendChild(this.eButton);
  }

  getGui() {
    return this.eGui;
  }

  destroy() {
    this.eButton.removeEventListener('click', this.buttonListener);
  }

  onButtonClicked() {
    this.params.onResetFilters?.();
    this.params.api.setFilterModel(null);
    this.params.api.resetColumnState();
  }
}
